import {Controller, useFormContext} from "react-hook-form";
import {StyledQuestionRequiredContainer} from "../../../../../../styles/onboarding/onboarding";
import {Switch} from "antd";
import {SessionSettingsFormFieldsType} from "../types";

export function SessionPauseSettingFormField() {
  const {control} = useFormContext<SessionSettingsFormFieldsType>();
  return (
    <div>
      <Controller
        control={control}
        name="isPaused"
        render={({field: {value, onChange}}) => (
          <StyledQuestionRequiredContainer>
            <span className="required-text">Need a break? Pause this session</span>
            <Switch onChange={onChange} checked={value} />{" "}
          </StyledQuestionRequiredContainer>
        )}
      />
    </div>
  );
}
